import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d292af2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = ["src"]

import ic_shita from '@/images/ic_shita.png'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'mobileFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("img", { src: _unref(ic_shita) }, null, 8, _hoisted_2),
      _createTextVNode(" 珠海视塔软件提供技术支持 ")
    ])
  ]))
}
}

})